module.exports = __webpack_public_path__ + "static/img/13.c145046.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/zh/13.png
// module id = MGuf
// module chunks = 0